<div class="wrapper">
  <div class="add-card ">
    <div class="custom_heading1 pb-2 d-flex align-items-center">
      <div class="icon-back" (click)="cancel()">
        <span class="material-symbols-outlined">
          arrow_back
        </span>
      </div>
      <span class="fw-600"> {{title}} Compliance</span>
    </div>
    <form class="form" [formGroup]="formData">
      <div class=" margin" style="max-width:100%">
        <div class=" m-0">
          <div class=" p-0 mb-2">
            <div class="row m-0">
              <div class="col-md-3 ">
                <div class="custom_paragraph">
                  <div class="py-2 field_heading adjust"><span class="secondaryInfo">Compliance Name <sup
                        class="error">*</sup></span>
                  </div>
                  <mat-form-field class="custom_select compliance-field"
                    [class.is-invalid]="formData.get('CompilanceName').invalid && formData.get('CompilanceName').touched && formData.get('CompilanceName').errors">
                    <mat-select placeholder="Select the Compliance Name" formControlName="CompilanceName">
                      <mat-option *ngFor="let location of complianceNames"
                        [value]="location.name">{{location.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="(formData.get('CompilanceName').invalid && formData.get('CompilanceName').touched && formData.get('CompilanceName').hasError)">
                  <div class="error" *ngIf="formData.get('CompilanceName').hasError('required')">Compliance Name is
                    required
                  </div>
                </div>
              </div>
              <div class="col-md-3 border-right">
                <div class="custom_paragraph">
                  <div class="py-2 field_heading"><span class="secondaryInfo ">Compliance Type<sup
                        class="error">*</sup></span>
                  </div>
                  <mat-form-field class="custom_select compliance-field"
                    [class.is-invalid]="formData.get('CompilanceType').invalid && formData.get('CompilanceType').touched && formData.get('CompilanceType').errors">
                    <mat-select placeholder="Select the Compliance Type" formControlName="CompilanceType">
                      <mat-option *ngFor="let location of complianceTypes"
                        [value]="location.name">{{location.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    *ngIf="(formData.get('CompilanceType').invalid && formData.get('CompilanceType').touched && formData.get('CompilanceType').hasError)">
                    <div class="error" *ngIf="formData.get('CompilanceType').hasError('required')">Compliance Type
                      is
                      required
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row m-0">
                  <div class="col-sm-6 p-0">
                    <div class="pr-2">
                      <span class="labelName">Start Date <sup class="requiredStar">*</sup></span>
                      <mat-form-field class="w-100 custom_date_picker createdate"
                        [class.is-invalid]="formData.get('startDate').invalid && (formData.get('startDate').touched || formData.get('startDate').dirty)">
                        <input matInput [matDatepicker]="picker" placeholder="Choose a Start Date"
                          formControlName="startDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <div class="pr-8 error"
                      *ngIf="(formData.get('startDate').invalid && formData.get('startDate').touched && formData.get('startDate').hasError)">
                      start Date is Required
                    </div>
                  </div>
                  <div class="col-sm-6 p-0">
                    <div class="pr-8 ">
                      <span class="labelName">Expiry Date <sup class="requiredStar">*</sup></span>
                      <mat-form-field class="w-100 custom_date_picker createdate"
                        [class.is-invalid]="formData.get('endDate').invalid && (formData.get('endDate').touched || formData.get('endDate').dirty)">
                        <input matInput [matDatepicker]="endpicker" placeholder="Choose a Expiry Date"
                          formControlName="endDate">
                        <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
                        <mat-datepicker #endpicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="pr-8 error"
                      *ngIf="(formData.get('endDate').invalid && formData.get('endDate').touched && formData.get('endDate').hasError)">
                      Expiry Date is Required
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="row m-0">
              <div class="col-md-6 border-right">
                <div class="custom_paragraph">
                  <div class="py-2 field_heading"><span class="secondaryInfo ">Description<sup
                        class="error">*</sup></span>
                  </div>
                  <input type="text" class="form-control disabled" formControlName="CompilanceDescription"
                    placeholder="Enter Description"
                    [class.is-invalid]="formData.get('CompilanceDescription').invalid && formData.get('CompilanceDescription').touched && formData.get('CompilanceDescription').errors">
                  <div
                    *ngIf="(formData.get('CompilanceDescription').invalid && formData.get('CompilanceDescription').touched && formData.get('CompilanceDescription').hasError)">
                    <div class="error" *ngIf="formData.get('CompilanceDescription').hasError('required')">Compilance
                      Description is
                      required
                    </div>
                    <div class="error"
                      *ngIf="formData.get('CompilanceDescription').errors.minlength||!formData.get('CompilanceDescription').errors.maxlength">
                      Min length should be 30 characters and max Length should be 400
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 m-0" style="padding-top:15px;">
                <div class="row m-0">
                  <div class="dropzone col-md-8 p-0" fileDragDrop (filesChangeEmiter)="fileUpload($event)">
                    <div class="text-wrapper">
                      <div class="upload_section ">
                        <input #file (change)="fileUpload($event.target.files)" type="file" class="form-control"
                          formControlName="Files" name="file" id="file" onclick="this.value = null" multiple
                          [accept]="allowedFileExtentions">
                        <label for="file"><i class="msicon"><span class="material-symbols-rounded">
                              backup
                            </span></i><span class=""> Drop
                            the relevant documents here / click to upload.</span>
                        </label>
                      </div>

                    </div>
                  </div>
                  <div class="file-list filename col-md-4">
                    <mat-chip-list class=" list-group list-group-flush">
                      <mat-chip class="list-group-item br-17 p-0" *ngIf="data?.fileName">
                        <div class="d-flex justify-content-between flex-column flex-sm-row gap-2">
                          <div class="d-flex align-items-center">
                            <i class="msicon"><span class="material-symbols-rounded">
                                draft
                              </span></i>
                            <div class="truncate-text">
                              {{data.fileName}}
                            </div>
                            <mat-icon class="pl-0" matChipRemove (click)="deleteFile()"
                              *ngIf="!isView">cancel</mat-icon>
                          </div>
                        </div>
                      </mat-chip>
                    </mat-chip-list>
                  </div>
                </div>

              </div>

            </div>

          </div>
          <table class="table-width" style="margin-left:25px;">
            <thead>
              <tr class="row">
                <th *ngFor="let region of data.regions" class="col px-1 table-max-width">
                  <mat-card class="header-mat">
                    <mat-card-content>{{ region.name }}</mat-card-content>
                  </mat-card>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="row">
                <td *ngFor="let region of data.regions" class="col px-1 table-max-width">
                  <div>
                    <div *ngFor="let country of region.countryList" style="background-color:#d9d9d9">
                      <div class="align sample">
                        <div class="row m-0 regionblock" style="width: 100%;">
                          <div class="col-4" style="padding:9px 8px;;"><span class="fw-600 countrytextname">{{
                              country.name }}</span></div>
                          <div class="col-8 p-2 filetexttruncate"><span class="color-gray">
                              {{country.fileName}}</span></div>
                          <div class="align delete-icon " *ngIf="!isView">
                            <div class="px-1">
                              <div class="file-upload">
                                <label [for]="country?.name">
                                  <i><span class="material-symbols-rounded">
                                      backup
                                    </span></i>
                                </label>
                                <input [id]="country?.name" type="file"
                                  (change)="countryFileChange(country,$event.target.files)" />
                              </div>
                            </div>
                            <div *ngIf="country.fileName">
                              <i (click)="changeCountryFileStatus(country, null)"><span
                                  class="material-symbols-rounded">
                                  delete
                                </span>
                              </i>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div *ngFor="let city of country.cityList" style="background-color:#e8e8e8">
                        <div class="align sample">
                          <div class="row m-0 countryblock" style="width: 100%;">
                            <div class="col-4 p-2"><span class="fw-600">{{ city.name }}</span></div>
                            <div class="col-8 p-2 filetexttruncate"><span class="color-gray">
                                {{city.fileName}}</span> </div>

                            <div class="align delete-icon " *ngIf="!isView">
                              <div class="px-1">
                                <div class="file-upload">
                                  <label [for]="city?.name">
                                    <i><span class="material-symbols-rounded">
                                        backup
                                      </span></i>
                                  </label>
                                  <input [id]="city?.name" type="file"
                                    (change)="cityFileChange(city,$event.target.files)" />
                                </div>

                              </div>
                              <div *ngIf="city.fileName">
                                <i (click)="changeCityFileStatus(city, null)"><span class="material-symbols-rounded">
                                    delete
                                  </span>
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngFor="let location of city.locationList" style="background-color:#f6f6f6">
                          <div class="align sample">
                            <div class="row m-0 locationblock" style="width: 100%;">
                              <div class="col-4 p-2"> <span class="fw-600 pl-1">{{ location.name }} </span></div>
                              <div class="col-8 p-2 filetexttruncate"><span
                                  class="color-gray ">{{location.fileName}}</span>
                              </div>
                              <div class="align delete-icon " *ngIf="!isView">
                                <div class="px-1">
                                  <div class="file-upload">
                                    <label [for]="location?.name">
                                      <i><span class="material-symbols-rounded">
                                          backup
                                        </span></i>
                                    </label>
                                    <input [id]="location?.name" type="file"
                                      (change)="locationFileChange(location, $event.target.files)" />
                                  </div>
                                </div>
                                <div *ngIf="location.fileName">
                                  <i class="material-symbols-rounded" (click)="location.fileName=null"><span> delete
                                    </span>
                                  </i>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="col-12 d-flex justify-content-end mb-2 pr-0">
            <button type="button" class="custom_btn inverted_btn_base mr-3" id="inv_setup_cancel" data-backdrop="static"
              data-keyboard="false" (click)="cancel()">Cancel
            </button>
            <button type="button" class="custom_btn primary_btn_base" id="inv_setup_save" data-backdrop="static"
              data-keyboard="false" *ngIf="!isView" (click)="save()">
              Submit</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>